/* global document */
module.exports = function Canvas() {
	return document.createElement('canvas');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/roslib/src/util/shim/canvas.js
// module id = 366
// module chunks = 0